import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseAddCommentParams {
	onSuccess?: (returnRequest: ReturnRequestDto) => void;
}

export default function useAddComment(params: UseAddCommentParams) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/comments",
		{
			notify: { success: false },
			onSuccess: params.onSuccess,
		},
	);
}
